<ngx-axs-modal
  class="client-ready-report-modal"
  [axsModalSize]="'medium'"
  [axsModalState]="isOpen"
  (axsModalClosed)="onModalClosed()"
>
  <div axsModalSlot class="client-ready-report-modal__surface">
    <div class="client-ready-report-modal__title text-title-2">
      {{ clientReadyReportModalContent?.whoIsBeingPrepared }}
    </div>
    <div class="client-ready-report-modal__content">
      <div class="client-ready-report-modal__field-group">
        <label class="client-ready-report-modal__label text-body-3" for="client-ready-report-name">
          {{ clientReadyReportModalContent?.clientName }}
        </label>

        <ngx-axs-input-text
          *ngIf="shouldRenderInput"
          appPiiMask="name"
          [axsCustomId]="'client-ready-report-name'"
          [axsAriaLabel]="clientReadyReportModalContent?.clientName || ''"
          [axsDesignType]="'outlined'"
          [axsType]="'text'"
          [axsMaxLength]="clientNameMaxLength"
          [ngModel]="clientName"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onClientNameInput($event)"
        ></ngx-axs-input-text>

        <div class="client-ready-report-modal__hint" aria-live="polite">
          <ngx-axs-icon
            class="client-ready-report-modal__hint-icon"
            axsType="infoOutline"
            axsAriaLabel="information"
            [axsWidth]="14"
            [axsHeight]="14"
          ></ngx-axs-icon>
          <span>{{ remainingCharactersText }}</span>
        </div>
      </div>

      <div class="client-ready-report-modal__actions">
        <ngx-axs-button
          class="client-ready-report-modal__download-button"
          axsType="primary"
          axsTheme="vg-red"
          axsSize="medium"
          [axsIsDisabled]="!hasClientName"
          [axsShowIcon]="true"
          axsIconType="download"
          [axsText]="clientReadyReportModalContent?.downloadClientReadyReport || ''"
          (axsClick)="onDownloadWithCustomization()"
        ></ngx-axs-button>

        <button
          type="button"
          class="client-ready-report-modal__download-link text-body-2"
          [disabled]="hasClientName"
          (click)="onDownloadWithoutCustomization()"
        >
          {{ clientReadyReportModalContent?.downloadWithoutCustomization }}
        </button>
      </div>
    </div>
  </div>
</ngx-axs-modal>